import { api } from '../api';
import { urls } from 'api/urls';

const buscarHistoricoDeAcoesDasPropostas = async (id: number) => await api.get(`${urls.historicoAcoes}/${id}`);

export { buscarHistoricoDeAcoesDasPropostas };
